import { useScroll, motion } from 'framer-motion';
import { useState } from 'react';
import { AboutUsImagesList } from './data';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
export default function AboutUs(){
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  };
  const[currentImage,setCurrentImage]=useState(0);
    // Section variants for staggered animations
const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
        when: "beforeChildren"
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };
    const { scrollYProgress } = useScroll();
    return <div id='about-us'>
       <motion.div 
       initial="hidden"
       whileInView="visible"
       viewport={{ once: true, amount: 0.2 }}
       variants={sectionVariants}
       >
       <div className="container" >
        
        <div className="about-us-container" >
            <motion.div
            initial={{ opacity: 0, y: 20 }} // Start hidden and 20px down
            animate={{ opacity: 1, y: 0 }}  // Animate to visible and original position
            transition={{ duration: 0.7 }}   // Animation duration
            >
            <div className="about-us-description">
                <motion.h1  variants={itemVariants} className="section-title">
               من هو Pockets
                </motion.h1>
<motion.p variants={itemVariants}>
<p>
نادي مليئ بالإثارة والترفيه والذكريات هنا تلتقي المتعة ودفئ اللقاءات بين الأصدقاء
 وتُحاك القصص بالتحديات في صالة البلياردو وتُعلن المنافسة عند أيادي البلايستيشن
  وتوزع نظرات الفطنة عند العاب الطاولة والبلوت لتبدأ سلسلة طويلة من التلاعب ولاننسى تفريغ الطاقة والحماس عند لعبة البوكسنج والكار درايف التي تحاكي الواقع بالكامل وتنقل تجربة حلبات السباق..بوكيت هو صندوق
  الذكريات الذي يحتفظ بـمتعتك في مراحل الحياة..وستجد اهتمامك يتجدد مع تجدد العمر في بوكيت لدينا مقهى مجهز بأحدث الآلات حول العالم ليضمن صفاء ذهنك قبل البدء في رحلة احتراف البلياردو، وللإستعداد لألعاب البلوت وجاكارو والكيرم التي تضفي أجواء الإنتماء في المكان
  وإضاءات ملائمة للألعاب الحركية والرقمية، وغرف جلوس للعزلة والمشاهدة بخصوصية وهدوء. 
</p>
</motion.p>
{/* <motion.div className='images8-class' 
initial="hidden"
whileInView="visible"
viewport={{ once: true, amount: 0.2 }}
variants={sectionVariants}>
<motion.img
src={require('../images/8img2.png')} alt='no-image'
variants={itemVariants}>

</motion.img>

</motion.div> */}

{/* <button className="btn"><a href="#">خدماتنا</a></button> */}
</div>
            </motion.div>

<div className="about-us-images">
    <motion.div className="about-us-main-img" variants={itemVariants}>
    <img src={AboutUsImagesList[currentImage].imgage} alt='no-image' />
    </motion.div>
   
<motion.div className="about-us-secondry-images"
initial="hidden"
whileInView="visible"
viewport={{ once: true, amount: 0.2 }}
variants={sectionVariants}
>
<Slider {...sliderSettings}>
{AboutUsImagesList.map((image,index)=>(
 <motion.div
 className= 'about-us-card ' onMouseEnter={() => setCurrentImage(index)}
 
 >


    <img src={image.imgage} alt='no-image' className={index === currentImage ? 'active' : ''}/>


 </motion.div>


  ))}
  </Slider>
  




</motion.div>


</div>
</div>
     

    </div>
       </motion.div>
    </div>
}